import { useAuthContext } from "../contexts/auth-context";
import { useEffect, useState } from "react";
import { TProcessStates } from "../lib/types/general";
import {
    getEmployeeRoles as _getEmployeeRoles,
    TEmployeeRolesFilters,
    updateEmployeeRole as _updateEmployeeRole,
    addEmployeeRole as _addEmployeeRole,
    TUpdateRole,
    TAddEmployeeRole,

    // TSkillsResults,
} from "../services/backoffice/backoffice-service";
import { TEmployeeRole } from "../lib/types/employee_roles";
import { TSkills, TSkillsFilters, TSkillsResults } from "../lib/types/skills";
import { getSkillListWithFilterNoLimit as _getSkillListWithFilterNoLimit } from "./generalInfo";

export const useEmployeeRoles = () => {
    const { getUserTokenId } = useAuthContext();
    const [workingState, setWorkingState] = useState<TProcessStates>("idle");
    const [employeeRoles, setEmployeeRoles] = useState<TEmployeeRole[]>([]);
    const [rolesCount, setRolesCount] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [allSkills, setAllSkills] = useState<TSkills[]>([]);
    const [skillCountWithFilter, setSkillCountWithFilter] = useState<number>(0);
    const [skillsForModal, setSkillsForModal] = useState<TSkills[]>([]);
    const props: TEmployeeRolesFilters = { name: "" };

    const getRolesList = async (
        offset: number,
        filterProps: TEmployeeRolesFilters
    ) => {
        setWorkingState("working");
        const userTokenId = await getUserTokenId();
        const _employeeRoles = await _getEmployeeRoles(
            offset,
            userTokenId,
            filterProps
        );
        const rolesData: TEmployeeRole[] =
            _employeeRoles.data.data.employeeRolesData;
        const rolesArray: TEmployeeRole[] = rolesData.map((role) => ({
            ...role,
            skills_count: role.skills.length,
        }));

        setEmployeeRoles(rolesArray);
        setRolesCount(_employeeRoles.data.data.totalRolesCount);
        setWorkingState("done");
    };

    const updateEmployeeRole = async (props: TUpdateRole) => {
        const userTokenId = await getUserTokenId();
        await _updateEmployeeRole(props, userTokenId);
        const offset = currentPage - 1;
        await getRolesList(offset, { name: props.search_name ?? "" });
    };

    const resetEmployeeList = async () => {
        await getRolesList(0, { name: "" });
        setCurrentPage(1);
    };

    const addNewEmployeeRole = async (props: TAddEmployeeRole) => {
        const userTokenId = await getUserTokenId();
        await _addEmployeeRole(props, userTokenId);
        return await getRolesList(0, { name: props.employee_role });
    };

    const getAllSkillsForEmployeeRoles = async (
        offset: number,
        filterProps: TSkillsFilters
    ) => {
        const userTokenId = await getUserTokenId();

        const _skillList = await _getSkillListWithFilterNoLimit(
            offset,
            userTokenId,
            filterProps,
            10000
        );

        setSkillCountWithFilter(_skillList.totalCount);
        setAllSkills(_skillList.skillsData);

        return {
            data: {
                skillsData: _skillList.skillsData,
                totalCount: _skillList.totalCount,
            },
        };
    };

    const getSkillListWithSearchFilterInAddModal = async (
        offset: number,
        filterProps: TSkillsFilters
    ): Promise<TSkillsResults> => {
        const userTokenId = await getUserTokenId();

        const skillListNoFilter = await _getSkillListWithFilterNoLimit(
            offset,
            userTokenId,
            filterProps,
            10000
        );

        setSkillsForModal(skillListNoFilter.skillsData);

        return {
            data: {
                skillsData: skillListNoFilter.skillsData,
                totalCount: skillListNoFilter.totalCount,
            },
        };
    };

    useEffect(() => {
        getRolesList(0, props);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        employeeRoles,
        workingState,
        rolesCount,
        getRolesList,
        updateEmployeeRole,
        currentPage,
        setCurrentPage,
        resetEmployeeList,
        addNewEmployeeRole,
        getSkillListWithSearchFilterInAddModal,
        allSkills,
        setAllSkills,
        skillCountWithFilter,
        skillsForModal,
        getAllSkillsForEmployeeRoles,
    };
};
